export const nonProtectedRoutes = {
  HOME: "/",
  LOGIN: "/login/",
  CONTACT: "/contact/",
  LOGOUT: "/logout/",
  PRICING: "/pricing/",
  CORPORATE_FIRMS: "/corporate-firms/",
  MERGE_ACQUISITIONS: "/mergers-acquisitions/",
  EC_VC: "/ec-vc/",
  SECURITY: "/security/",
  RESPONSIBLE_AI: "/responsible-ai/",
  REGISTER: "/register/",
  TERMS: "/terms-of-service/",
  ACTIVATE: "/activate/:token/",
  NOT_FOUND: "/not-found/",
};

export const protectedRoutes = {
  CHECKOUT: "checkout",
  DASHBOARD: "/app/dashboard/",
  PAYMENT_SUCCESS: "checkout/success/",
  PAYMENT_CANCEL: "checkout/cancel/",
  TENANT_ADMIN: "tenant/",
  PROFILE: "profile/",
};

export default nonProtectedRoutes;
